import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prg-select-loop',
  templateUrl: './select-loop.component.html',
  styleUrls: ['./select-loop.component.css']
})
export class SelectLoopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/select-loop/select-loop.component.ts